<template>
    <div>
        <div
            v-if="!collapsed"
            @click="toggle"
            class="flex items-center justify-between px-4 py-3 cursor-pointer hover:bg-green-800 text-sm font-bold uppercase"
        >
            <span
                v-if="!collapsed"
                class="text-xs uppercase font-bold text-green-200"
                >{{ title }}</span
            >

            <!-- Chevron -->
            <svg
                v-if="!collapsed"
                :class="{ 'rotate-90': open }"
                class="w-4 h-4 ml-2 transition-transform duration-200 transform"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                viewBox="0 0 24 24"
                stroke-linecap="round"
                stroke-linejoin="round"
            >
                <path d="M9 5l7 7-7 7" />
            </svg>
        </div>

        <transition name="fade">
            <div
                v-show="open"
                class="space-y-1"
            >
                <inertia-link
                    v-for="(item, index) in items"
                    :key="`${title}-${item.name}-${index}`"
                    :href="route(item.routeName)"
                    class="relative flex items-center px-6 py-3 text-sm font-medium group hover:bg-green-800 rounded"
                    :class="{ 'bg-green-700': isActive(item.routeName) }"
                    @mouseenter="collapsed && showTooltip($event, title, index)"
                    @mouseleave="collapsed && hideTooltip()"
                >
                    <component
                        :is="item.icon"
                        :fill="item.fill"
                        class="w-5 h-5"
                    />
                    <span
                        v-if="!collapsed"
                        class="ml-3"
                        >{{ item.name }}</span
                    >
                </inertia-link>

                <portal to="tooltip-target">
                    <div
                        v-if="tooltipVisible"
                        :style="tooltipStyle"
                        class="fixed z-50 bg-green-800 text-white text-sm px-2 py-2 rounded shadow-lg whitespace-nowrap transition-opacity duration-200"
                    >
                        {{ tooltipText }}
                    </div>
                </portal>
            </div>
        </transition>
        <portal-target
            name="tooltip-target"
            multiple
        ></portal-target>
    </div>
</template>

<script>
    export default {
        props: {
            title: String,
            items: Array,
            collapsed: Boolean,
        },
        data() {
            return {
                open: false,
                tooltipVisible: null,
                tooltipText: '',
                tooltipStyle: {
                    top: '0px',
                    left: '0px',
                },
            };
        },
        mounted() {
            const savedState = localStorage.getItem(`sidebar_group_${this.title}`);
            this.open = this.collapsed ? true : savedState ? JSON.parse(savedState) : this.shouldBeOpenInitially();
        },
        watch: {
            open(val) {
                localStorage.setItem(`sidebar_group_${this.title}`, JSON.stringify(val));
            },
            collapsed: {
                immediate: true,
                handler(val) {
                    this.open = val ? true : this.shouldBeOpenInitially();
                },
            },
        },
        methods: {
            toggle() {
                if (!this.collapsed) {
                    this.open = !this.open;
                }
            },
            shouldBeOpenInitially() {
                return this.items.some((item) => this.isActive(item.routeName));
            },
            isActive(routeName) {
                return this.route().current(routeName) || this.$page.url.includes(routeName);
            },

            showTooltip(event, title, index) {
                const rect = event.currentTarget.getBoundingClientRect();
                this.tooltipStyle = {
                    top: `${rect.top + rect.height}px`,
                    left: `${rect.right + 2}px`,
                };
                this.tooltipVisible = `${title}-${index}`;
                this.tooltipText = this.items[index].name;
            },
            hideTooltip() {
                this.tooltipVisible = null;
            },
        },
    };
</script>

<style scoped>
    .fade-enter-active,
    .fade-leave-active {
        transition: all 0.3s ease;
    }
    .fade-enter,
    .fade-leave-to {
        opacity: 0;
        max-height: 0;
    }
</style>
